import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import "../styles.css";
import { listarVehiculos, listarMaquinaria, listarUtillaje, crearItem, actualizarItem } from "../api";
import { toast } from "react-toastify";

function ModalCrearItem({ onClose, item }) {
  const [nombre, setNombre] = useState(item?.nombre || "");
  const [referencia, setReferencia] = useState(item?.referencia || "");
  const [cantidad, setCantidad] = useState(item?.cantidad || 0);

  const [vehiculosOptions, setVehiculosOptions] = useState([]);
  const [maquinariasOptions, setMaquinariasOptions] = useState([]);
  const [utillajesOptions, setUtillajesOptions] = useState([]);

  const [vehiculosSeleccionados, setVehiculosSeleccionados] = useState([]);
  const [maquinariasSeleccionadas, setMaquinariasSeleccionadas] = useState([]);
  const [utillajesSeleccionados, setUtillajesSeleccionados] = useState([]);

  const [activeTab, setActiveTab] = useState("vehiculos");

  useEffect(() => {
    const cargarListas = async () => {
      try {
        const [v, m, u] = await Promise.all([
          listarVehiculos(),
          listarMaquinaria(),
          listarUtillaje(),
        ]);

        setVehiculosOptions(v.map((veh) => ({ value: veh.id, label: `${veh.nombre} (${veh.matricula})` })));
        setMaquinariasOptions(m.map((maq) => ({ value: maq.id, label: `${maq.nombre} (${maq.matricula})` })));
        setUtillajesOptions(u.map((ut) => ({ value: ut.id, label: `${ut.nombre} (${ut.matricula})` })));

        if (item?.id) {
          setVehiculosSeleccionados(item.vehiculos_compatibles?.map(x => ({ value: x.id, label: `${x.nombre} (${x.matricula})` })) || []);
          setMaquinariasSeleccionadas(item.maquinarias_compatibles?.map(x => ({ value: x.id, label: `${x.nombre} (${x.matricula})` })) || []);
          setUtillajesSeleccionados(item.utillajes_compatibles?.map(x => ({ value: x.id, label: `${x.nombre} (${x.matricula})` })) || []);
        }
      } catch (err) {
        console.error("Error cargando listas:", err);
      }
    };
    cargarListas();
  }, [item]);

  const handleGuardar = async () => {
    if (!nombre || !referencia) {
      toast.warning("Nombre y referencia son obligatorios");
      return;
    }

    const data = {
      nombre,
      referencia,
      cantidad,
      vehiculos_ids: vehiculosSeleccionados.map(v => v.value),
      maquinarias_ids: maquinariasSeleccionadas.map(m => m.value),
      utillajes_ids: utillajesSeleccionados.map(u => u.value),
    };

    try {
      const objGuardado = item?.id
        ? await actualizarItem(item.id, data)
        : await crearItem(data);

      onClose(objGuardado);
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Error al guardar el ítem");
    }
  };

  const getCurrentOptions = () => {
    switch (activeTab) {
      case "vehiculos": return vehiculosOptions;
      case "maquinaria": return maquinariasOptions;
      case "utillaje": return utillajesOptions;
      default: return [];
    }
  };

  const getCurrentSeleccionados = () => {
    switch (activeTab) {
      case "vehiculos": return vehiculosSeleccionados;
      case "maquinaria": return maquinariasSeleccionadas;
      case "utillaje": return utillajesSeleccionados;
      default: return [];
    }
  };

  const setCurrentSeleccionados = (values) => {
    switch (activeTab) {
      case "vehiculos": setVehiculosSeleccionados(values || []); break;
      case "maquinaria": setMaquinariasSeleccionadas(values || []); break;
      case "utillaje": setUtillajesSeleccionados(values || []); break;
    }
  };

  const CustomOption = (props) => {
    const isSelected = props.isSelected;
    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input type="checkbox" checked={isSelected} readOnly />
          <span>{props.label}</span>
        </div>
      </components.Option>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-modern" style={{ position: "relative" }}>
        <button className="modal-close-button" onClick={onClose}>✖</button>

        <h2>{item ? "Editar Item" : "Crear Item"}</h2>

        <div className="form-group">
          <label>Nombre</label>
          <input value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre..." />
        </div>

        <div className="form-group">
          <label>Referencia</label>
          <input value={referencia} onChange={e => setReferencia(e.target.value)} placeholder="Referencia..." />
        </div>

        <div className="form-group">
          <label>Cantidad</label>
          <input type="number" value={cantidad} onChange={e => setCantidad(Number(e.target.value))} min={0} />
        </div>

        <div className="tabs">
          <button className={activeTab === "vehiculos" ? "active" : ""} onClick={() => setActiveTab("vehiculos")}>Vehículos</button>
          <button className={activeTab === "maquinaria" ? "active" : ""} onClick={() => setActiveTab("maquinaria")}>Maquinaria</button>
          <button className={activeTab === "utillaje" ? "active" : ""} onClick={() => setActiveTab("utillaje")}>Utillaje</button>
        </div>

        <div className="form-group">
          <label>Selecciona {activeTab} compatibles</label>
          <Select
            isMulti
            options={getCurrentOptions()}
            value={getCurrentSeleccionados()}
            onChange={setCurrentSeleccionados}
            placeholder="Busca y selecciona..."
            components={{ Option: CustomOption }}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? "#008cff" : "#ccc",
                boxShadow: state.isFocused ? "0 0 6px rgba(0,140,255,0.3)" : "none",
                "&:hover": { borderColor: "#008cff" },
                minHeight: "42px",
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused ? "#e9f2ff" : "white",
                color: "#333",
                cursor: "pointer",
              }),
            }}
          />
        </div>

        <div className="modal-actions">
          <button className="botonPrimario" onClick={handleGuardar}>{item ? "Actualizar" : "Añadir"}</button>
          <button className="botonSecundario" onClick={() => onClose()}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default ModalCrearItem;
